import { useState, useEffect, useRef } from 'react';
import ImageCheckFallback from '../../shared/components/ImageCheckFallback';

const MobileBannerSlider = ({ mainBanner, handleCountClickBanner }) => {
    const [mobileSlideIndex, setMobileSlideIndex] = useState(0);
    const [enableTransition, setEnableTransition] = useState(true);
    const total = mainBanner ? mainBanner.length : 0;
    const slides = mainBanner && mainBanner.length > 0 ? [...mainBanner, mainBanner[0]] : [];

    const touchStartX = useRef(null);
    const timerRef = useRef(null);

    const startTimer = () => {
        if (total <= 1) return;
        timerRef.current = setInterval(() => {
            setEnableTransition(true);
            setMobileSlideIndex((prev) => prev + 1);
        }, 5000);
    };

    const stopTimer = () => {
        if (timerRef.current) clearInterval(timerRef.current);
    };

    useEffect(() => {
        startTimer();
        return () => stopTimer();
    }, [total]);

    useEffect(() => {
        if (mobileSlideIndex === total) {
            const timeout = setTimeout(() => {
                setEnableTransition(false);
                setMobileSlideIndex(0);
            }, 800);
            return () => clearTimeout(timeout);
        }
    }, [mobileSlideIndex, total]);

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
        stopTimer();
    };

    const handleTouchEnd = (e) => {
        if (touchStartX.current === null) return;
        const diff = touchStartX.current - e.changedTouches[0].clientX;
        setEnableTransition(true);
        if (diff > 50) {
            // vuốt trái → next
            setMobileSlideIndex((prev) => prev + 1);
        } else if (diff < -50) {
            // vuốt phải → prev
            setMobileSlideIndex((prev) => (prev <= 0 ? total - 1 : prev - 1));
        }
        touchStartX.current = null;
        startTimer();
    };

    return (
        <div
            className="scrollable-area scrollable-area-1"
            style={{ overflow: 'hidden', position: 'relative' }}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
        >
            <div
                style={{
                    display: 'flex',
                    gap: 0,
                    fontSize: 0,
                    transform: `translateX(-${mobileSlideIndex * 100}%)`,
                    transition: enableTransition ? 'transform 1s ease-in-out' : 'none',
                    willChange: 'transform',
                }}
            >
                {slides.map((item, index) => (
                    <div
                        key={`main-banner-2-${index}`}
                        style={{ minWidth: '100%', margin: 0, padding: 0, lineHeight: 0 }}
                    >
                        <a
                            href={item?.linkUrlApp}
                            rel="nofollow"
                            target={item?.linkTypeApp === 'window' ? '_self' : item?.linkTypeApp}
                            style={{ display: 'block', lineHeight: 0 }}
                            onClick={async (e) => {
                                if (item?.linkType !== '_blank') e.preventDefault();
                                await handleCountClickBanner(item?.seq);
                                try {
                                    if (item?.linkTypeApp === 'window') {
                                        window.open(item?.linkUrlApp, '_blank', 'width=1200,height=1000');
                                    } else if (item?.linkType !== '_blank') {
                                        window.location.href = item?.linkUrl;
                                    }
                                } catch (error) {
                                    console.error(error);
                                }
                            }}
                        >
                            <div style={{ width: '100%', overflow: 'hidden' }}>
                                <ImageCheckFallback
                                    folderName={'banner_photo_main'}
                                    imgName={item?.imgNameAppMain320px}
                                    classImg={'d-block carousel-img-res'}
                                    alt="DentalJob"
                                    imgStyle={{ width: '100%' }}
                                />
                            </div>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MobileBannerSlider;